import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography';
import { TeamAvatar } from '@sorare/core/src/components/club/TeamAvatar';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';

import { GameHeader_game } from './__generated__/index.graphql';

type Props = {
  game?: GameHeader_game;
};

export const GameHeader = ({ game }: Props) => {
  const { up: isLaptopOrAbove } = useScreenSize('laptop');
  if (!game) {
    return null;
  }
  const { homeTeam, awayTeam } = game;
  return (
    <Horizontal>
      <TeamAvatar team={homeTeam} />
      <HeadlineM as="h3">
        <FormattedMessage
          id="rivals.match.slug.vs"
          defaultMessage="{home} vs {away}"
          values={{
            home: isLaptopOrAbove ? homeTeam?.shortName : homeTeam?.code,
            away: isLaptopOrAbove ? awayTeam?.shortName : awayTeam?.code,
          }}
        />
      </HeadlineM>
      <TeamAvatar team={awayTeam} />
    </Horizontal>
  );
};

GameHeader.fragments = {
  game: gql`
    fragment GameHeader_game on Game {
      id
      homeTeam {
        slug
        shortName
        code
        ...TeamAvatar_team
      }
      awayTeam {
        slug
        shortName
        code
        ...TeamAvatar_team
      }
    }
    ${TeamAvatar.fragments.team}
  ` as TypedDocumentNode<GameHeader_game>,
};
